export default {"src":"/_next/static/media/telegram.cf54bb59.svg","height":10,"width":12};